<ng-template #modal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Información de contacto </h4>
      <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="btn-close" type="button"></button>
    </div>
    <div class="modal-body">
        <h4 class="fs-5 text-colonial mb-2">Dirección de contacto</h4>
        <div class="card rounded-3 my-3 p-3 d-flex flex-column gap-2" style="border: 1px solid #d0d0d0 !important;">
            <div class="d-flex flex-column gap-0">
                <span class="fw-semibold">Calle</span>
                <span>{{contact.street}}</span>
            </div>
            <div class="d-flex flex-column gap-0">
                <span class="fw-semibold">Estado</span>
                <span>{{contact.state}}</span>
            </div>
            <div class="d-flex flex-column gap-0">
                <span class="fw-semibold">Ciudad</span>
                <span>{{contact.city}}</span>
            </div>
            <div class="d-flex flex-column gap-0">
                <span class="fw-semibold">País</span>
                <span>{{contact.country || 'N/A'}}</span>
            </div>
            <div class="d-flex flex-column gap-0">
                <span class="fw-semibold">Código Postal</span>
                <span>{{contact.postalCode || 'N/A'}}</span>
            </div>
        </div>
        <h4 class="fs-5 text-colonial mb-2">Información de contacto</h4>
        <div class="card rounded-3 my-3 p-3 d-flex flex-column gap-2" style="border: 1px solid #d0d0d0 !important;">
            <div class="d-flex flex-column gap-0">
                <span class="fw-semibold">Email</span>
                <span>{{contact.email}}</span>
            </div>
            <div class="d-flex flex-column gap-0">
                <span class="fw-semibold">Teléfono</span>
                <span>{{contact.phone}}</span>
            </div>
        </div>

        @if(emergencyContact && emergencyContact.email){
            <h4 class="fs-5 text-colonial mb-2">Contacto de emergencia</h4>
            <div class="card rounded-3 my-3 p-3 d-flex flex-column gap-2" style="border: 1px solid #d0d0d0 !important;">
                <div class="d-flex flex-column gap-0">
                    <span class="fw-semibold">Email</span>
                    <span>{{emergencyContact.email}}</span>
                </div>
                <div class="d-flex flex-column gap-0">
                    <span class="fw-semibold">Teléfono</span>
                    <span>{{emergencyContact.phone}}</span>
                </div>
            </div>
        }


    </div>
    <div class="modal-footer">
      <button (click)="modal.dismiss('Cross click')" class="btn btn-outline-dark" type="button">Cerrar</button>
    </div>
</ng-template>
